import PropTypes from "prop-types";
import IconButton from "@mui/material/IconButton";
import Icon from "@mui/material/Icon";
import ListItem from "@mui/material/ListItem";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import { useDispatch } from "react-redux";
import { removeLineItem } from "store/vino/cartSlice";
import Image from "vino/components/Image";
import { FormattedAmount } from "vino/core";

const CartProductItem = ({ lineItem }) => {
	const dispatch = useDispatch();
	const { product, variant } = lineItem;
	const { name } = product;
	const total = variant.price * lineItem.quantity;

	return (
		<>
			<ListItem className="px-8">
				<Image className="w-40 h-full rounded-16 block mr-5" image={product} />
				<div className="flex flex-1 flex-col relative overflow-hidden">
					<div className="flex justify-between">
						<Typography
							className="truncate text-14 font-semibold"
							variant="subtitle1"
						>
							{name}
						</Typography>
					</div>

					<Typography color="textSecondary" className="truncate">
						{variant.name}
					</Typography>

					<div className="flex w-full justify-between">
						<Typography className="font-semibold">
							{lineItem.quantity} x <FormattedAmount value={variant.price} />
						</Typography>

						<FormattedAmount className="font-semibold" value={total} />
					</div>
				</div>
			</ListItem>
			<Divider component="li" />
		</>
	);
};

CartProductItem.propTypes = {
	lineItem: PropTypes.object.isRequired,
};

export default CartProductItem;
